<!-- Table -->
<div class="px-4 pb-4">
	<!-- Form Select -->
	<div class="pb-4 bg-gray-50">
		<div class="flex justify-between items-center">
			<div>
				<ui-dropdown
					[items]="dropdownItems()"
					[placeholder]="getSelectedFormName()"
					size="lg"
					(itemSelected)="onDropdownItemSelected($event)"
				>
					<ui-button
						dropdown-trigger
						preset="EXTRA_LOW_EMPHASIS"
						[label]="getSelectedFormName()"
						size="md"
						rightIcon="chevron-down"
					/>
				</ui-dropdown>
			</div>

			<div class="flex justify-center items-center gap-2">
				<ui-button
					preset="EXTRA_LOW_EMPHASIS"
					size="md"
					rightIcon="chevron-left"
					(click)="goToPreviousForm()"
				/>
				<ui-button
					preset="EXTRA_LOW_EMPHASIS"
					size="md"
					rightIcon="chevron-right"
					(click)="goToNextForm()"
				/>
			</div>
		</div>
	</div>

	<!-- Header -->
	<div
		class="sticky top-0 z-10 grid grid-cols-[1fr_1fr_1fr_150px] border border-grey-lighter font-medium bg-white rounded-t-xl"
	>
		<div class="text-sm text-gray-950 pl-6 py-3 pr-3">Form Question</div>
		<div class="text-sm text-gray-950 pr-6 py-3 pl-3">Client Response</div>

		@if (showMatterDetailsColumn()) {
			<div class="text-sm text-gray-950 pr-6 py-3 pl-3">Matter Details</div>
		}

		<div class="flex justify-end items-center gap-4">
			@if (showSelectAllCheckbox()) {
				<span class="text-sm text-gray-950">Select All</span>
				<ui-checkbox
					[ngModel]="areAllItemsSelected()"
					(click)="onSelectAllClick($event)"
					class="mr-4"
				></ui-checkbox>
			}
		</div>

		@if (showStatusColumn()) {
			<div class="text-sm text-gray-950 pr-6 py-3 pl-3">Status</div>
		}
	</div>

	<!-- Sections -->
	@for (
		section of sections();
		track section.title;
		let sectionFirst = $first;
		let sectionLast = $last
	) {
		<!-- Section Header -->
		<div
			class="flex justify-between pt-4 pb-3 px-6 border-grey-lighter cursor-pointer bg-white hover:bg-gray-100 active:bg-gray-200 duration-300 items-center group"
			[class.rounded-b-xl]="isSectionCollapsed(section.title) && sectionLast"
			[ngClass]="sectionFirst ? 'border-b border-x' : 'border'"
			(click)="toggleCollapsed(section.title)"
		>
			<div class="text-gray-950 font-medium text-xl">{{ section.title }}</div>
			<div
				class="flex justify-center items-center w-8 h-8 duration-300 border border-gray-300 group-active:border-2 rounded-md text-gray-500"
				[class.rotate-180]="isSectionCollapsed(section.title)"
			>
				<tabler-icon name="chevron-up" class="w-4 h-4"></tabler-icon>
			</div>
		</div>

		<!-- Collapsible Rows Container -->
		<div
			class="duration-300 grid"
			[class.grid-rows-[1fr]]="!isSectionCollapsed(section.title)"
			[class.grid-rows-[0fr]]="isSectionCollapsed(section.title)"
		>
			<div class="overflow-hidden">
				<!-- Rows -->
				<div
					class="border-x border-grey-lighter bg-white"
					[class.border-b]="sectionLast"
					[class.rounded-b-xl]="sectionLast"
				>
					@for (row of section.data; track row.questionId; let last = $last) {
						<div
							class="grid grid-cols-[1fr_1fr_1fr_150px]"
							[class.border-b]="!last"
							[class.border-grey-lighter]="!last"
						>
							<div class="overflow-hidden min-w-0">
								<app-intake-responses-row
									class="text-sm text-gray-950"
									[answer]="row.formQuestion"
									[clientName]="getSelectedFormName()"
									[isTitleCell]="true"
								/>
							</div>

							<div class="overflow-hidden min-w-0">
								<app-intake-responses-row
									class="text-sm text-gray-700"
									[answer]="row.clientResponse"
									[friendlyAnswer]="row.friendlyClientResponse"
									[clientName]="getSelectedFormName()"
									[isTitleCell]="false"
								/>
							</div>

							@if (showMatterDetailsColumn()) {
								<div class="overflow-hidden min-w-0">
									<app-intake-responses-row
										class="text-sm text-gray-700"
										[answer]="row.matterDetails"
										[friendlyAnswer]="row.friendlyMatterDetails"
										[clientName]="getSelectedFormName()"
										[isTitleCell]="false"
									/>
								</div>
							}

							<div class="flex justify-end items-center">
								@if (row.status === fieldResponseStatus.ADDED_TO_MATTER) {
									@if (clientResponseMatchesMatterDetails(row)) {
										<img
											src="assets/images/closer-logo-green-c.png"
											alt="Added to matter"
											class="w-4 h-4 mr-6"
											matTooltip="Matches matter"
											matTooltipShowDelay="1000"
										/>
									} @else {
										<tabler-icon
											name="check"
											class="w-4 h-4 text-gray-600 mr-6"
											matTooltip="Added to matter"
											matTooltipShowDelay="1000"
										></tabler-icon>
									}
								} @else if (
									row.status === fieldResponseStatus.MISSING_RESPONSES
								) {
									<span
										class="text-sm text-gray-700 mr-6"
										matTooltip="No response"
										matTooltipShowDelay="1000"
										>-</span
									>
								} @else if (
									row.status === fieldResponseStatus.READY_TO_REVIEW
								) {
									<ui-checkbox
										[ngModel]="isRowSelected(row)"
										(ngModelChange)="onRowToggled(row, $event)"
										matTooltip="Select to add"
										matTooltipShowDelay="1000"
										class="mr-4"
									></ui-checkbox>
								}
							</div>
						</div>
					}
				</div>
			</div>
		</div>
	}
</div>
